import { Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { fromClassroom } from 'shared/classroom/data-access';
import { ToolbarActions, ToolbarUiStateService } from 'shared/classroom/toolbar/data-access';
import { map } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { GoToParentSlideButtonComponent } from '../../go-to-parent-slide-button/go-to-parent-slide-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-go-to-parent-slide',
    templateUrl: './toolbar-button-go-to-parent-slide.component.html',
    styleUrls: ['./toolbar-button-go-to-parent-slide.component.scss'],
    imports: [GoToParentSlideButtonComponent, AsyncPipe]
})
export class ToolbarButtonGoToParentSlideComponent {
    private readonly store: Store = inject(Store);
    private readonly toolbarUiState = inject(ToolbarUiStateService);

    readonly hasParentSlide$ = this.store.select(
        fromClassroom.selectNavigationPreviewHasParent
    );
    readonly goToParentInProcess$ = toObservable(this.toolbarUiState.goToParentInProcess);
    readonly isDisabled$ = combineLatest([
        this.hasParentSlide$,
        this.goToParentInProcess$,
    ]).pipe(
        map(
            ([hasParentSlide, goToParentInProcess]) =>
                !hasParentSlide || goToParentInProcess
        )
    );

    public goToParentSlide() {
        this.store.dispatch(ToolbarActions.toolbarNavigateToParent());
    }
}

